import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import AdminRoutes from './routes/Admin/Routes';

const RoutesApp = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="push-notifications" replace />} />
        <Route path="/*" element={<AdminRoutes />} />
      </Routes>
    </BrowserRouter>
  );
};

export default RoutesApp;
